document.addEventListener('DOMContentLoaded', function () {
  const btn = document.querySelector('.js-other-nl-button');
  const btnMobile = document.querySelector('.js-other-nl-button-mobile');
  const otherNl = document.querySelector('.js-other-nl');
  const icons = [
    btn ? btn.querySelector('.fa-solid') : null,
    btnMobile ? btnMobile.querySelector('.fa-solid') : null
  ].filter(Boolean);

  function setIcons(direction) {
    icons.forEach(icon => {
      icon.style.transform = direction === 'down' ? 'rotate(0deg)' : 'rotate(180deg)';
    });
  }

  function showOtherNl() {
    otherNl.classList.remove('d-none');
    otherNl.style.maxHeight = otherNl.scrollHeight + 'px';
    otherNl.style.transition = 'max-height 0.4s cubic-bezier(0.4,0,0.2,1)';
    setTimeout(() => {
      otherNl.style.maxHeight = 'none';
    }, 400);
    setIcons('up');
  }

  function hideOtherNl() {
    otherNl.style.maxHeight = otherNl.scrollHeight + 'px';
    setTimeout(() => {
      otherNl.style.maxHeight = '0';
    }, 10);
    setIcons('down');
    setTimeout(() => {
      otherNl.classList.add('d-none');
      otherNl.style.maxHeight = '';
      otherNl.style.transition = '';
    }, 400);
  }

  function toggleOtherNl() {
    if (otherNl.classList.contains('d-none')) {
      showOtherNl();
    } else {
      hideOtherNl();
    }
  }

  // Nastav výchozí stav šipek
  if (otherNl && icons.length) {
    if (otherNl.classList.contains('d-none')) {
      setIcons('down');
    } else {
      setIcons('up');
    }
  }

  if (btn) {
    btn.addEventListener('click', toggleOtherNl);
    btn.addEventListener('keydown', function(event) {
      if (event.key === 'Enter') {
        toggleOtherNl();
      }
    });
  }

  if (btnMobile) {
    btnMobile.addEventListener('click', toggleOtherNl);
    btnMobile.addEventListener('keydown', function(event) {
      if (event.key === 'Enter') {
        toggleOtherNl();
      }
    });
  }

});


/* Modal open */
document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (e) {
    const link = e.target.closest('a[data-modal]');
    if (!link) return;

    e.preventDefault();
    e.stopPropagation();

    const modalToOpen = link.getAttribute('data-modal');
    const modalWrapper = document.querySelector('.modal-wrapper');

    if (modalWrapper) {
      modalWrapper.classList.add('open');

      if (modalToOpen) {
        modalWrapper.querySelectorAll('.modal.active').forEach((modal) => {
          modal.classList.remove('active');
        });

        const targetModal = modalWrapper.querySelector(modalToOpen);
        if (targetModal) {
          targetModal.classList.add('active');
        }
      }

      const activeModal = modalWrapper.querySelector('.modal.active');
      if (activeModal) {
        const firstInput = activeModal.querySelector('input');
        if (firstInput) {
          firstInput.focus();
        }
      }

      document.body.classList.add('modal-open');
    }
  });
});

/* close modal */
document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (e) {
    if (e.target.closest('a[data-modal]')) {
      return;
    }

    const closeBtn = e.target.closest('.modal-wrapper .modal .close, .modal-wrapper .modal .js-modal-close');
    if (!closeBtn) return;

    e.preventDefault();
    e.stopPropagation();

    const messageBoxes = document.querySelectorAll('.modal-message-box.pop-up');
    messageBoxes.forEach(box => box.classList.add('hidden'));

    const modal = closeBtn.closest('.modal');
    const wrapper = closeBtn.closest('.modal-wrapper');

    if (wrapper) {
      wrapper.classList.remove('open');
    }

    if (modal) {
      modal.classList.remove('active');
    }

    document.body.classList.remove('modal-open');

    const redirectUrl = closeBtn.getAttribute('data-redirect');
    if (redirectUrl) {
      window.location.href = redirectUrl;
    }
  });
});
